module.exports = __webpack_public_path__ + "img/Pic_About.b726b2ee.jpg";